export default [
  {
    path: '/main',
    name: 'main-index',
    component: () => import('@/views/main/Main.vue'),
    meta: {
      isHeader: false,
      isNav: true,
      isBack: false,
      titleName: 'Main View'
    }
  },
  {
    // 260529 메인 개편 와이어프레임 미리보기 (라이브 메인 미변경). 검증 후 /main으로 승격 예정.
    path: '/main-wire',
    name: 'main-wireframe',
    component: () => import('@/views/main/MainWireframe.vue'),
    meta: {
      isHeader: false,
      isNav: false,
      isBack: false,
      titleName: 'Main Wireframe'
    }
  },
  {
    // 260601 검색 결과 레이아웃 시안 (리스트/격자/앨범/간판네온 비교)
    path: '/search-wire',
    name: 'search-wireframe',
    component: () => import('@/views/main/SearchWireframe.vue'),
    meta: {
      isHeader: false,
      isNav: false,
      isBack: false,
      titleName: 'Search Wireframe'
    }
  },
  {
    path: '/search',
    component: () => import('@/views/main/Search.vue'),
    meta: {
      isHeader: false,
      isNav: true,

      isBack: false,
      titleName: 'Main View'
    }
  },
  {
    path: '/menu/select',
    component: () => import('@/views/main/SmileCrySelect.vue'),
    meta: {
      isHeader: false,
      isNav: true,

      isBack: false,
      titleName: 'Select View'
    }
  }
];
